
import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Loader2 } from "lucide-react";
import { useLegalSettings } from "./legal/useLegalSettings";
import TermsTab from "./legal/TermsTab";
import PrivacyTab from "./legal/PrivacyTab";
import DocumentsTab from "./legal/DocumentsTab";
// Import ReactQuill CSS for styling the editor
import "react-quill/dist/quill.snow.css";

const LegalContentManager = () => {
  const {
    loading,
    saving,
    termsValue,
    setTermsValue,
    privacyValue,
    setPrivacyValue,
    handleSaveTerms,
    handleSavePrivacy,
    getLastUpdatedText
  } = useLegalSettings();
  
  const [activeTab, setActiveTab] = useState("terms");

  if (loading) {
    return (
      <div className="flex justify-center p-8">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Legal Content</CardTitle>
          <CardDescription>
            Manage legal content including terms and conditions, privacy policy, and legal documents
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue={activeTab} onValueChange={(value) => setActiveTab(value)}>
            <div className="border-b border-border mb-4">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="terms">Terms & Conditions</TabsTrigger>
                <TabsTrigger value="privacy">Privacy Policy</TabsTrigger>
                <TabsTrigger value="documents">Documents</TabsTrigger>
              </TabsList>
            </div>
            
            <TabsContent value="terms" className="space-y-4">
              <TermsTab
                termsValue={termsValue}
                setTermsValue={setTermsValue}
                getLastUpdatedText={getLastUpdatedText}
                handleSaveTerms={handleSaveTerms}
                saving={saving}
              />
            </TabsContent>
            
            <TabsContent value="privacy" className="space-y-4">
              <PrivacyTab
                privacyValue={privacyValue}
                setPrivacyValue={setPrivacyValue}
                getLastUpdatedText={getLastUpdatedText}
                handleSavePrivacy={handleSavePrivacy}
                saving={saving}
              />
            </TabsContent>
            
            <TabsContent value="documents" className="space-y-4">
              <DocumentsTab />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default LegalContentManager;
